var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackArrowIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_10367_19051",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 3,
    width: 17,
    height: 18
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.4202 5.25103C12.7131 4.95814 12.7131 4.48327 12.4202 4.19037C12.1273 3.89748 11.6524 3.89748 11.3595 4.19037L4.05951 11.4904C3.9188 11.6311 3.83978 11.822 3.83984 12.021C3.83991 12.22 3.91907 12.4108 4.05988 12.5514L11.3299 19.8114C11.623 20.1041 12.0978 20.1038 12.3905 19.8107C12.6832 19.5176 12.6829 19.0427 12.3898 18.75L6.38224 12.7507H19.2498C19.664 12.7507 19.9998 12.4149 19.9998 12.0007C19.9998 11.5865 19.664 11.2507 19.2498 11.2507H6.42051L12.4202 5.25103Z",
    fill: "#101010"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_10367_19051)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#101010"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackArrowIcon);
export default __webpack_public_path__ + "static/media/back-arrow-icon.990d7cd3affb59a5cb68ccbb25cba8e1.svg";
export { ForwardRef as ReactComponent };